import React from "react";
import "../../Styles/ModalCart.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

const ModalCart = ({ children, image, title, btnText, book, close }) => {
    const navigator = useNavigate();
    const location = useLocation();
    // const handelButton = () => {
    //     close()
    //     if (location?.state.prevPath) {
    //         navigator(location?.state.prevPath);
    //     }
    // }
    return (
        <div className="modal-wrapper">
            <div className="ModalCart_box">
                <img src={image} alt="icon image" />
                <h3 className="number-font">{title}</h3>
                {children}
                <button className="number-font"
                    onClick={close}>
                    {/* onClick={()=> {navigator("/cart", {state:{prevPath: `/book/${window.location.pathname.split("/")[2]/${book.preTitle}}`}}) }} */}
                    {btnText}
                </button>
            </div>
        </div>
    );
};

export default ModalCart;
